var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2099 0.736989L16.1354 0.670291C16.4245 0.347354 16.8625 0.218542 17.2634 0.292294L17.2651 0.292567L17.2651 0.292602C17.3247 0.303597 17.3776 0.319671 17.4307 0.337762L17.4308 0.337774C17.5795 0.388471 17.7206 0.469075 17.8433 0.580195L17.8434 0.580282L21.7132 4.09346L21.7132 4.09353L21.646 4.16757C22.0949 4.5742 22.1317 5.28318 21.7287 5.73363L16.2099 0.736989ZM16.2099 0.736989L16.1354 0.670294L2.6542 15.7311C2.65396 15.7314 2.65371 15.7317 2.65346 15.7319C2.57813 15.8129 2.52351 15.9109 2.49401 16.0173L2.49397 16.0175L0.628283 22.7961L0.628164 22.7965C0.560135 23.0482 0.639573 23.3167 0.833507 23.4907L16.2099 0.736989ZM15.1872 3.80538L17.0477 1.72529L20.6601 4.99618L18.7996 7.07627L15.1872 3.80538ZM4.13327 16.1463L14.2644 4.8253L17.8752 8.10506L7.75465 19.4192L4.13327 16.1463ZM2.33278 21.8331L3.53428 17.4556L6.52358 20.1713L2.33278 21.8331Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EditIcon.dc0daf12.svg";
export { ForwardRef as ReactComponent };